import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/nl/over-ons", "nl", "about");
